import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function WhatChanges() {
  return <section className="py-20 px-4 bg-cream" data-id="element-142">
      <div className="max-w-3xl mx-auto text-center" data-id="element-143">
        <FadeIn data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-800 mb-12" data-id="element-145">
            What Changes (Practically)
          </h2>

          <p className="text-xl text-text-body mb-8" data-id="element-146">
            You're not buying motivation. You're buying:
          </p>

          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 text-left" data-id="element-147">
            <ul className="space-y-6" data-id="element-148">
              {['A calmer bedtime routine', 'Fewer 2 AM troubleshooting spirals', 'Less dry mouth and fewer leak wakeups (because you address causes in order)', 'A simple daily log that makes appointments and adjustments productive', 'A process that helps CPAP become boring (which is the goal)'].map((item, i) => <li key={i} className="flex items-start" data-id="element-149">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-teal-100 flex items-center justify-center mr-4 mt-1" data-id="element-150">
                    <Check className="h-4 w-4 text-teal-700" data-id="element-151" />
                  </div>
                  <span className="text-lg text-text-body" data-id="element-152">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}